/* eslint-disable */
import $ from 'jquery';

const header = document.querySelector('[data-header]');

if(header !== null) {
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 450) {
      header.classList.add('is--minimal');
    } else {
      header.classList.remove('is--minimal');
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/header.js